/** Convention-based public paths for platform-curated CFB branding assets. */

export const CFB_BRANDING_ASSET_BASE = '/lsc/team-assets/cfb';

export type CfbIconExt = 'png' | 'svg';

export function cfbPrimaryLogoPath(schoolId: string): string {
  return `${CFB_BRANDING_ASSET_BASE}/primary/${schoolId}.png`;
}

export function cfbIconLogoPath(schoolId: string, iconExt: CfbIconExt = 'png'): string {
  return `${CFB_BRANDING_ASSET_BASE}/icon/${schoolId}.${iconExt}`;
}

export function resolveConventionBrandingUrls(
  schoolId: string,
  logoStatus: string,
  logoIconExt?: string | null
): { primary_url: string; icon_url: string } | null {
  if (logoStatus !== 'licensed' || !schoolId.trim()) {
    return null;
  }
  const ext: CfbIconExt = logoIconExt === 'svg' ? 'svg' : 'png';
  return {
    primary_url: cfbPrimaryLogoPath(schoolId),
    icon_url: cfbIconLogoPath(schoolId, ext),
  };
}
